import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import chat from "./locales/en/chat.json";
import common from "./locales/en/common.json";
import dashboard from "./locales/en/dashboard.json";
import home from "./locales/en/home.json";
import landing from "./locales/en/landing.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common,
        landing,
        dashboard,
        chat,
        home,
      },
    },
    lng: "en",
    fallbackLng: "en",
    defaultNS: "common",
    ns: ["common", "landing", "dashboard", "chat", "home"],
    interpolation: {
      escapeValue: false,
    },
  });

export { i18n };
